<div *ngIf="isNGS">
  <nav class="navbar navbar-expand-lg navbar-dark fixed-top navbar-default" aria-label="Navbar" id="header">
    <!-- +++++ HEADER = BRANDING = Title of the site  +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
    <div class="navbar-header pt-5">
      <a class="navbar-brand" href="#">
        <!-- SITE NAME -->
        <strong>
          <h4>Blueberry</h4>
        </strong>
      </a>
      <!-- BUILD INFORMATION -->
      <p [hidden]="production" id="buildInfo" (click)="showBuildInfo($event, buildInfoOverlay)"
        style="color:white; width: 100px; text-align: center; margin-top: -2rem;">
        {{buildNo}}
      </p>
      <p-overlayPanel #buildInfoOverlay [hidden]="production">
        <ul id="buildOverlay">
          <li> MDM Service : {{mdmServiceBuildNo}}</li>
          <li> API Gateway Service : {{apiGatewayServiceBuildNo}}</li>
          <li> APGNGS Service: {{apgServiceBuildNo}}</li>
          <li> Entry QC Service: {{ngsEntryQcBuildNo}}</li>
          <li> NGS RunPlanning Service: {{ngsRunPlanningBuildNo}}</li>
          <li> Animal Order Service: {{animalOrderServiceBuildNo}}</li>
          <li> Ticket Service : {{TicketServiceBuildNo}}</li>
          <li> NGS Library Prepration Service : {{ngsLibPrepServiceBuildNo}}</li>
          <li> Lab Measurement Service : {{labMeasurementServiceBuildNo}}</li>
          <li> Sample Reception Service : {{sampleReceptionServiceBuildNo}}</li>
        </ul>
      </p-overlayPanel>
    </div>
    <!-- +++++ TOGGLER: will only display on narrow screen (mobile devices...) to allow user to access the menu +++++++++++++++++++++++++++++++++++++++++++ -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- +++++ TITLE BAR ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
    <div class="collapse navbar-collapse" id="navbarSupportedContent">

      <!-- Standard main menu = left aligned -->
      <ul class="navbar-nav mr-auto">

        <li ngbDropdown class="nav-item">
          <a ngbDropdownToggle class="nav-link" role="button" id="navbarDropdown" aria-expanded="false">
            <em class="fa fa-fw fa-user-md"></em> Artic & Midplex</a>
          <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item text-100" routerLink="covid19unboxing" routerLinkActive="activatedRouterLink">
              <em class="fa fa-fw fa-barcode"></em> Order Reception</a>
            <a class="dropdown-item text-100" routerLink="covid19entryNew" routerLinkActive="activatedRouterLink">
              <em class="fa fa-fw fa-user-md"></em> Artic Samples</a>
            <a class="dropdown-item text-100" routerLink="covid19MidplexSamples" routerLinkActive="activatedRouterLink">
              <em class="fa fa-fw fa-user-md"></em> Midplex Samples</a>
            <a class="dropdown-item text-100" routerLink="midplex-merge" routerLinkActive="activatedRouterLink">
              <em class="fa fa-compress"></em> Merge 384</a>
            <a class="dropdown-item text-100" routerLink="artic-lab-planning" routerLinkActive="activatedRouterLink">
              <em class="fa fa-table"></em> Lab Planning</a>
            <a class="dropdown-item text-100" routerLink="artic-delivery-planning" routerLinkActive="activatedRouterLink">
              <em class="fa fa-table"></em> Delivery Planning</a>
            <a class="dropdown-item text-100" routerLink="invoicing-item" routerLinkActive="activatedRouterLink">
              <em class="fa fa-table"></em> Invoicing</a>
            <a class="dropdown-item text-100" routerLink="customer-track" routerLinkActive="activatedRouterLink">
              <em class="fa fa-search"></em> Track</a>
          </div>
        </li>

        <li class="nav-item" routerLink="printCustomLabels" routerLinkActive="activatedRouterLink">
          <app-print-plate-labels></app-print-plate-labels> <!--Print Labels -->
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="ngs-sample-arrival" routerLinkActive="activatedRouterLink">
            <em class="fa fa-fw fa-user-md"></em> Sample Arrival </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="ngs-extraction" routerLinkActive="activatedRouterLink">
            <em class="fa fa-barcode"></em> Extraction </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="worklist" routerLinkActive="activatedRouterLink">
            <em class="far fa-hand-rock"></em> Lib Prep </a>
        </li>

        <li class="nav-item" ngbDropdown>
          <a class="nav-link" ngbDropdownToggle role="button" aria-haspopup="true" aria-expanded="false">
            <em class="fa fa-braille"></em> Runs
          </a>
          <div class="dropdown-menu" ngbDropdownMenu style="background: linear-gradient(to bottom, #f6f7f9 0%, #ebedf0 100%); color: #1b1d1f !important;
                position: absolute;
                box-shadow: 0 1px 3px 0 rgb(0 0 0 / 30%);
                border: 1px solid #D5D5D5;">
            <a class="dropdown-item" routerLink="runplan/onholdproject">On hold Projects</a>
            <a class="dropdown-item" routerLink="runplan/trackLibraies">Track Libraries</a>
            <a class="dropdown-item" routerLink="runplan">Run Planning</a>
            <a class="dropdown-item" routerLink="runscheduling">Run Scheduling</a>
            <a class="dropdown-item" routerLink="runprocess">Run Processing</a>
          </div>
        </li>        

        <li ngbDropdown class="nav-item">
          <a ngbDropdownToggle class="nav-link" role="button" aria-haspopup="true" aria-expanded="false">
            <em class="fa fa-braille"></em> Machine Files</a>
          <div ngbDropdownMenu class="dropdown-menu" style="background: linear-gradient(to bottom, #f6f7f9 0%, #ebedf0 100%); color: #1b1d1f !important;
                position: absolute;
                box-shadow: 0 1px 3px 0 rgb(0 0 0 / 30%);
                border: 1px solid #D5D5D5;">
            <a class="dropdown-item" routerLink="measurements-results">Results</a>
            <a class="dropdown-item" routerLink="libprep-workfiles">WorkFiles</a>
          </div>
        </li>        

        <li class="nav-item">
          <a class="nav-link" routerLink="apg-adminstration" routerLinkActive="activatedRouterLink">
            <em class="fa fa-lock"></em> Administration </a>
        </li>

      </ul>
      <!-- Special menu = right aligned -->
      <ul class="navbar-nav navbar-right">
        <!-- LOCATION -->
        <li class="nav-item">
          <p-button class="h-2rem border-round" (click)="changeLab()" 
          [model]="link"  pTooltip="Click here to change Lab" tooltipPosition="bottom" >{{selectedLab.label}}</p-button>
        </li>&nbsp;&nbsp;
        <!-- ADMINISTRATION -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/admin/masterdata" routerLinkActive="activatedRouterLink">
            <em class="fa fa-fw fa-gears fa-lg"></em>
          </a>
        </li>
        <li *ngIf="loginStatus" class="nav-item">
          <a class="nav-link" routerLink="/logout" routerLinkActive="activatedRouterLink" (click)="logOut()">
            <em class="fa fa-fw fa-sign-out fa-lg"></em>
          </a>
        </li>
        <li *ngIf="azureLoginStatus" class="nav-item">
          <a class="nav-link" (click)="azureLogOut()">
            <em class="fa fa-fw fa-sign-out fa-lg"></em>
          </a>
        </li>
      </ul>
    </div>
    <div class="topright" *ngIf="azureLoginStatus">
      {{loggedUserName}}<em class="fa fa-user" style="margin-left: 5px;" aria-hidden="true"></em>
    </div>
  </nav>
</div>

<messages class="message-service"></messages>
<router-outlet></router-outlet>
